module.exports = __webpack_public_path__ + "img/capitol_building.fe1a9f0f.jpg";